import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from '../Button/Button';
import useLogin from '../../Features/Autenticacion/Hooks/useLogin';
import { useToast } from '../../Hooks/useToast';
import { SimularCalculoCDOService } from '../../Services/SimularCalculoCDOService';

const INITIAL_VALUES = {
	mes1: '',
	mes2: '',
	mes3: '',
	conducta: '',
	adaptacion: '',
	desempeno: '',
};

const OPTIONS = [
	{ value: '0', label: '0% Alto' },
	{ value: '50-medio', label: '50% Medio' },
	{ value: '100-bajo', label: '100% Bajo' },
];

const QUESTIONS = [
	{ key: 'conducta', label: 'Conducta diligente del Concesionario.', variableId: 1 },
	{
		key: 'adaptacion',
		variableId: 2,
		label: 'Haber adaptado las medidas de mitigacion o reparacion necesarias respecto al desempeno operacional insuficiente.',
	},
	{ key: 'desempeno', label: 'Desempeno operacional insuficiente reiterado.', variableId: 3 },
];

const MONTH_FIELD_NAMES = new Set(['mes1', 'mes2', 'mes3']);

const colors = {
	text: '#7794AC',
	card: '#FFFFFF',
	modal: '#F1F6FA',
	divider: '#F7F7F7',
	border: '#7794AC',
	button: '#043087',
	buttonIconBg: '#F7F8FA',
	buttonIconBorder: '#BFCFDB',
};

const styles = {
	wrapper: {
		background: colors.modal,
		borderRadius: '28px',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		gap: '40px',
		alignItems: 'center',
		justifyContent: 'center',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
		alignItems: 'flex-start',
		width: '100%',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: '16px',
		alignSelf: 'stretch',
		width: '100%',
	},
	title: {
		color: colors.text,
		fontSize: '18px',
		lineHeight: '24px',
		fontWeight: 600,
		margin: 0,
	},
	description: {
		color: colors.text,
		fontSize: '14px',
		lineHeight: '16px',
		fontWeight: 500,
		margin: 0,
		alignSelf: 'stretch',
	},
	card: {
		background: colors.card,
		borderRadius: '8px',
		padding: '16px',
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		alignItems: 'stretch',
		justifyContent: 'flex-start',
		alignSelf: 'stretch',
	},
	sectionLabel: {
		color: colors.text,
		fontSize: '12px',
		lineHeight: '16px',
		fontWeight: 600,
		margin: 0,
		alignSelf: 'stretch',
		textAlign: 'left',
	},
	inputsRow: {
		display: 'flex',
		flexDirection: 'row',
		gap: '16px',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		width: '100%',
	},
	fieldWrapper: {
		position: 'relative',
		height: '74px',
		width: '120px',
	},
	fieldLabel: {
		position: 'absolute',
		left: '12px',
		top: 0,
		padding: '0 4px',
		background: colors.card,
		color: colors.text,
		fontSize: '12px',
		lineHeight: '16px',
		fontWeight: 400,
		zIndex: 1,
	},
	fieldInput: {
		width: '100%',
		height: '48px',
		borderRadius: '4px',
		border: `1px solid ${colors.border}`,
		padding: '12px 16px',
		marginTop: '7px',
		color: colors.text,
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		outline: 'none',
	},
	questionBlock: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		alignItems: 'flex-start',
		width: '100%',
	},
	questionLabel: {
		color: colors.text,
		fontSize: '12px',
		lineHeight: '16px',
		fontWeight: 500,
		margin: 0,
		width: '100%',
		textAlign: 'left',
	},
	questionList: {
		margin: 0,
		paddingLeft: '16px',
	},
	questionItem: {
		paddingLeft: '4px',
	},
	optionsRow: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '16px',
		alignItems: 'center',
	},
	radioOption: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		cursor: 'pointer',
		color: colors.text,
		fontSize: '12px',
		lineHeight: '16px',
		fontWeight: 500,
	},
	radioCircle: {
		width: '16px',
		height: '16px',
		borderRadius: '50%',
		border: `1px solid ${colors.border}`,
		background: '#FFFFFF',
		position: 'relative',
		flexShrink: 0,
	},
	radioInner: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '8px',
		height: '8px',
		borderRadius: '50%',
		background: colors.button,
	},
	divider: {
		height: '1px',
		background: '#E0DED8',
		width: '100%',
	},
	resultSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: '0px',
		width: '100%',
	},
	resultTitle: {
		color: colors.text,
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '16px',
		padding: 0,
		border: 'none',
		margin: 0,
		paddingBottom: '8px',
	},
	resultRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
	},
	resultLabelCell: {
		borderBottom: '1px solid #E0DED8',
		padding: '6px 10px',
		width: '157px',
	},
	resultValueCell: {
		borderBottom: '1px solid #E0DED8',
		padding: '6px 10px',
		width: '235px',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	resultLabel: {
		color: colors.text,
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '24px',
		margin: 0,
	},
	resultValue: {
		color: colors.text,
		fontSize: '14px',
		fontWeight: 700,
		lineHeight: '24px',
		margin: 0,
		textAlign: 'right',
	},
	actions: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'flex-start',
		gap: '16px',
		paddingTop: '16px',
	},
	iconButton: {
		width: '48px',
		height: '48px',
		minWidth: '48px',
		minHeight: '48px',
		padding: 0,
		borderRadius: '10px',
		border: `1px solid ${colors.buttonIconBorder}`,
		background: colors.buttonIconBg,
		boxSizing: 'border-box',
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	primaryActionButton: {
		height: '48px',
		padding: '14px 24px',
		borderRadius: '8px',
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: '182px',
	},
};

const parsePercent = (rawValue) => {
	if (rawValue === null || rawValue === undefined || rawValue === '') {
		return 0;
	}

	const normalized = String(rawValue).replace(',', '.').replace(/[^0-9.]/g, '');
	const parsed = Number(normalized);

	if (Number.isNaN(parsed)) {
		return 0;
	}

	if (parsed < 0) {
		return 0;
	}

	if (parsed > 100) {
		return 100;
	}

	return parsed;
};

const sanitizeMonthInput = (rawValue) => {
	if (rawValue === null || rawValue === undefined) {
		return '';
	}

	const normalizedValue = String(rawValue)
		.replace(/\s+/g, '')
		.replace(/\./g, ',');

	if (normalizedValue === '') {
		return '';
	}

	if (!/^\d{0,3}(,\d{0,2})?$/.test(normalizedValue)) {
		return null;
	}

	const [integerPart = '', decimalPart] = normalizedValue.split(',');
	const integerValue = integerPart === '' ? 0 : Number(integerPart);

	if (Number.isNaN(integerValue) || integerValue > 100) {
		return null;
	}

	if (integerValue === 100 && decimalPart !== undefined && /[1-9]/.test(decimalPart)) {
		return null;
	}

	return normalizedValue;
};

const buildSimulationVariables = (formValues) => {
	return QUESTIONS.map((question) => ({
		variableId: question.variableId,
		alto: formValues[question.key] === '0',
		medio: formValues[question.key] === '50-medio',
		bajo: formValues[question.key] === '100-bajo',
	}));
};

const buildErrorMessage = (responseData) => {
	if (responseData?.errors && typeof responseData.errors === 'object') {
		const firstError = Object.values(responseData.errors).find((messages) => Array.isArray(messages) && messages.length > 0);
		if (firstError) {
			return firstError[0];
		}
	}

	if (responseData?.mensaje) {
		return responseData.mensaje;
	}

	if (responseData?.title) {
		return responseData.title;
	}

	return 'Ha ocurrido un error al simular el calculo.';
};

const MesField = ({ label, name, value, onChange }) => {
	return (
		<div style={styles.fieldWrapper}>
			<label htmlFor={name} style={styles.fieldLabel}>{label}</label>
			<input
				id={name}
				name={name}
				type='text'
				inputMode='decimal'
				maxLength={6}
				autoComplete='off'
				placeholder='Ingresa %'
				value={value}
				onChange={onChange}
				style={styles.fieldInput}
			/>
		</div>
	);
};

const RadioGroup = ({ name, value, onChange }) => {
	return (
		<div style={styles.optionsRow}>
			{OPTIONS.map((option) => {
				const checked = value === option.value;

				return (
					<label key={option.value} style={styles.radioOption}>
						<input
							type='radio'
							name={name}
							value={option.value}
							checked={checked}
							onChange={onChange}
							style={{ display: 'none' }}
						/>
						<span style={styles.radioCircle}>{checked ? <span style={styles.radioInner} /> : null}</span>
						<span>{option.label}</span>
					</label>
				);
			})}
		</div>
	);
};

const ModalSimuladorIsp = ({
	show,
	onHide,
	onInfoClick,
	onSubmit,
	title = 'Simulador ISP',
}) => {
	const { user, usuario } = useLogin();
	const addToast = useToast();
	const [values, setValues] = useState(INITIAL_VALUES);
	const [simulationResult, setSimulationResult] = useState(null);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const areMonthFieldsCompleted = ['mes1', 'mes2', 'mes3'].every((fieldName) => {
		return String(values[fieldName] ?? '').trim() !== '';
	});

	const handleChange = ({ target: { name, value } }) => {
		if (MONTH_FIELD_NAMES.has(name)) {
			const sanitizedValue = sanitizeMonthInput(value);

			if (sanitizedValue === null) {
				return;
			}

			setValues((prevState) => ({ ...prevState, [name]: sanitizedValue }));
			return;
		}

		setValues((prevState) => ({ ...prevState, [name]: value }));
	};

	const resetSimulation = () => {
		setValues(INITIAL_VALUES);
		setSimulationResult(null);
	};

	const handleClose = () => {
		resetSimulation();
		onHide();
	};

	const handleSubmit = async () => {
		const userId = user?.id || usuario?.id || 0;
		const profileContextId = usuario?.perfilContexto?.id || user?.perfilContexto?.id || 0;

		const payload = {
			idUsuario: Number(userId),
			idPerfilContexto: Number(profileContextId),
			mes1: parsePercent(values.mes1),
			mes2: parsePercent(values.mes2),
			mes3: parsePercent(values.mes3),
			variables: buildSimulationVariables(values),
		};

		setIsSubmitting(true);
		try {
			const response = await SimularCalculoCDOService(payload);

			if (response?.status === 200 && response.data) {
				setSimulationResult({
					isp: response.data.isp ?? 0,
					cdoUf: response.data.rangoCDO ?? '0 - 0',
					calculoUf: response.data.calculoUf ?? 0,
				});

				onSubmit?.(values);
				return;
			}

			addToast({
				mostrar: true,
				mensaje: buildErrorMessage(response?.data),
				titulo: 'Error',
				tipo: 'Danger',
			});
		} catch (error) {
			addToast({
				mostrar: true,
				mensaje: buildErrorMessage(error?.response?.data),
				titulo: 'Error',
				tipo: 'Danger',
			});
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<Modal
			show={show}
			onHide={handleClose}
			size='md'
			centered
			backdropClassName='backdrop-dark'
			className='modal--bg-gray'
			aria-labelledby='contained-modal-title-vcenter'
		>
			<Modal.Body className='p-4'>
				<div style={styles.wrapper}>
					<div style={styles.content}>
						<div style={styles.header}>
							<h5 style={styles.title}>{title}</h5>
							<Button type='button' design='btn-outline-pewter-blue p-2 lh-1 fs-3' onClick={handleClose}>
								<i className='ico-close'></i>
							</Button>
						</div>

						<p style={styles.description}>
							Ingresa las variables solicitadas para generar la simulacion del trimestre.
						</p>

						<div style={styles.card}>
							<h6 style={styles.sectionLabel}>Variables</h6>

						<div style={styles.inputsRow}>
							<MesField label='Mes 1' name='mes1' value={values.mes1} onChange={handleChange} />
							<MesField label='Mes 2' name='mes2' value={values.mes2} onChange={handleChange} />
							<MesField label='Mes 3' name='mes3' value={values.mes3} onChange={handleChange} />
						</div>

							{QUESTIONS.map((question, index) => (
							<div key={question.key} style={styles.questionBlock}>
									<p style={styles.questionLabel}>{`${index + 1}.${question.label}`}</p>
								<RadioGroup name={question.key} value={values[question.key]} onChange={handleChange} />
								{index < QUESTIONS.length - 1 || simulationResult ? <div style={styles.divider} /> : null}
							</div>
						))}

							{simulationResult ? (
								<div style={styles.resultSection}>
									<h6 style={styles.resultTitle}>Resultado de simulacion</h6>
									<div style={styles.resultRow}>
										<div style={styles.resultLabelCell}>
											<p style={styles.resultLabel}>ISP</p>
										</div>
								<div style={styles.resultValueCell}>
											<p style={styles.resultValue}>{simulationResult.isp}</p>
										</div>
									</div>
									<div style={styles.resultRow}>
										<div style={{ ...styles.resultLabelCell, borderBottom: 'none' }}>
											<p style={styles.resultLabel}>CDO UF</p>
										</div>
										<div style={{ ...styles.resultValueCell, borderBottom: 'none' }}>
											<OverlayTrigger
												placement='top'
												overlay={
												<Tooltip id='tooltip-calculo-uf'>
													{`${simulationResult.calculoUf} UF`}
												</Tooltip>
												}
											>
												<p tabIndex={0} style={{ ...styles.resultValue, cursor: 'help' }}>
													{simulationResult.cdoUf}
												</p>
											</OverlayTrigger>
										</div>
									</div>
								</div>
							) : null}

							<div style={styles.actions}>
							<button
								type='button'
								className='link text-pewter-blue fs-5'
								style={styles.iconButton}
								onClick={onInfoClick}
								aria-label='Informacion simulador ISP'
							>
								<i className='ico-info-circle'></i>
							</button>
							<Button
								type='button'
								design='btn-primary btn-mm'
								onClick={simulationResult ? resetSimulation : handleSubmit}
								disabled={simulationResult ? false : isSubmitting || !areMonthFieldsCompleted}
								style={styles.primaryActionButton}
							>
								{simulationResult ? 'Limpiar simulacion' : isSubmitting ? 'Simulando...' : 'Simular'}
							</Button>
							</div>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default ModalSimuladorIsp;
